module.exports = __webpack_public_path__ + "img/medal4.ddfebf45.png";